<template>
  <div id="app">
    <v-app id="inspire">
      <v-row
        class="supplier-detail custom-border-top mt-3"
        v-if="loglist.length > 0"
      >
        <v-col md="12" sm="12" class="">
          <div class="d-flex align-center justify-space-between">
            <v-btn-toggle v-model="leaveStatusType">
              <v-btn value="all" class="py-2">
                <v-avatar color="blue" class="white--text mr-2" size="25">{{
                  statusCounts.all
                }}</v-avatar>
                <span class="hidden-sm-and-down">All</span>
              </v-btn>

              <v-btn value="pending" class="py-2">
                <v-avatar color="orange" class="white--text mr-2" size="25">{{
                  statusCounts.pending
                }}</v-avatar>
                <span class="hidden-sm-and-down font-size-18">Pending</span>
              </v-btn>

              <v-btn value="accepted" class="py-2">
                <v-avatar color="success" class="white--text mr-2" size="25">{{
                  statusCounts.accepted
                }}</v-avatar>
                <span class="hidden-sm-and-down">Approved</span>
              </v-btn>

              <v-btn value="rejected" class="py-2">
                <v-avatar color="red" class="white--text mr-2" size="25">{{
                  statusCounts.rejected
                }}</v-avatar>
                <span class="hidden-sm-and-down">Rejected</span>
              </v-btn>
              <v-btn value="cancelled" class="py-2">
                <v-avatar color="teal" class="white--text mr-2" size="25">{{
                  statusCounts.cancelled
                }}</v-avatar>
                <span class="hidden-sm-and-down">Cancelled</span>
              </v-btn>
            </v-btn-toggle>
            <div class="d-flex" v-if="false">
              <DateRangePicker
                prop_id="duration-picker"
                :page-loading="pageLoading"
                prop_label="Date Range"
                v-model="duration"
              ></DateRangePicker>
              <v-autocomplete
                :items="leaveTypes"
                v-model="leaveType"
                dense
                flat
                filled
                clearable
                label="Category"
                v-on:click:clear="clearFilter('category')"
                item-color="cyan"
                color="cyan"
                solo
                :disabled="pageLoading"
                v-on:change="leaveFilter"
                item-value="name"
                item-text="name"
                class="filter-select ml-2"
              />
            </div>
          </div>
        </v-col>
        <v-col md="12" sm="12" class="pt-0">
          <v-skeleton-loader
            class="custom-skeleton"
            v-if="pageLoading"
            type="table-tbody"
          >
          </v-skeleton-loader>
          <v-simple-table v-else class="simple-table">
            <template v-slot:default>
              <thead>
                <tr style="background-color: #f3f6f9; color: #24326d">
                  <!-- <td>
                           
                        </td> -->
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Leave #
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Date
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Leave Type
                  </td>

                  <td class="font-size-13 text-uppercase font-weight-500">
                    No. of Days
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Applied At
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Status
                  </td>

                  <td class="font-size-13 text-uppercase font-weight-500">
                    Action date
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Attachments
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(leave, index) in filteredLogs"
                  :key="index"
                  :class="{
                    'custom-border-top': index == 0,
                    'orange_lighten-5': index % 2 == 0,
                  }"
                >
                  <!-- <td>
                          <v-checkbox v-model="selectedRows" class="hide-margin" color="cyan" dense hide-details
                            v-bind:value="leave.id"></v-checkbox>
                        </td> -->
                  <td link class="font-size-14 font-weight-500 text-capitalize">
                    <v-chip
                      outlined
                      label
                      color="blue"
                      class="mb-1"
                      @click.stop.prevent="redirectToDetail(leave)"
                    >
                      {{ leave.barcode }}
                    </v-chip>
                  </td>
                  <td link class="font-size-14 font-weight-500">
                    <template v-if="leave && leave.start_date">
                      <div>Start: {{ formatDate(leave.start_date) }}</div>
                      <div>End: {{ formatDate(leave.end_date) }}</div>
                    </template>
                    <em v-else class="text-muted"> no date</em>
                  </td>
                  <td link class="font-size-14 font-weight-500">
                    <template v-if="leave && leave.category">
                      <v-chip outlined label color="orange" class="mb-1">
                        {{ leave.category }}
                      </v-chip>
                      <br />
                    </template>
                    <em v-else class="text-muted"> no leave type</em>
                  </td>

                  <td link class="font-size-14 font-weight-500 text-lowercase">
                    <template v-if="leave && leave.total_leave_days">
                      <v-avatar class="white--text" color="primary" size="26">
                        {{ leave.total_leave_days }}
                      </v-avatar>
                    </template>
                    <em v-else class="text-muted"> no. of days</em>
                  </td>
                  <td class="font-size-14 font-weight-500">
                    <template v-if="leave && leave.created_at">
                      <v-chip outlined label color="red">
                        {{ leave.created_at }}</v-chip
                      >
                    </template>
                    <em v-else class="text-muted"> no applied at</em>
                  </td>
                  <td link class="font-size-14 font-weight-500">
                    <template v-if="leave && leave.status">
                      <v-menu
                        :disabled="isDisabled(leave)"
                        offset-y
                        min-width="100px"
                        style="padding: 0px 4px"
                        rounded
                        bottom
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on">
                            <v-chip
                              style="height: 25px"
                              class="ml-1 mb-1 pl-2 pr-1 text-capitalize"
                              :color="`${leave.status_color} white--text`"
                              outlined
                              dence
                              text-color=""
                            >
                              {{ leave.status_text }}
                              <v-icon style="font-size: 22px"
                                >mdi-menu-down</v-icon
                              >
                            </v-chip>
                          </div>
                        </template>
                        <v-list>
                          <v-list-item
                            class="list-item cursor-pointer p-1"
                            v-for="(item, index) in statusDropdown"
                            :key="index"
                            @click="updateStatus(item.value, leave)"
                          >
                            <v-list-item-title class="pl-4">{{
                              item.text
                            }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <!-- <v-chip outlined class="text-white" label :color="leave.status_color">
                              {{ leave.status_text }} 
                            </v-chip> -->
                    </template>
                    <em v-else class="text-muted"> no status</em>
                  </td>

                  <td class="font-size-14 font-weight-500">
                    <template v-if="leave && leave.status > 1">
                      <span v-if="leave.status == 2">
                        <TableActivity
                          v-if="!lodash.isEmpty(leave.approved_by)"
                          :data="leave"
                        >
                          <template v-slot:display_name>
                            {{ leave.approved_by?.display_name }}
                          </template>
                          <template v-slot:date_time>
                            <template
                              v-if="getDateCountAll(leave.approved_at)"
                              >{{ formatDateTime(leave.approved_at) }}</template
                            >
                            <template v-else>{{
                              formatDateTime(leave.approved_at)
                            }}</template>
                          </template>
                          <template v-slot:format_date_time>
                            {{ formatDate(leave.approved_at) }}
                            {{ formatDateStartTime(leave.approved_at) }}
                          </template>
                        </TableActivity>
                      </span>
                      <span v-if="leave.status == 3">
                        <TableActivity
                          v-if="!lodash.isEmpty(leave.rejected_by)"
                          :data="leave"
                        >
                          <template v-slot:display_name>
                            {{ leave.rejected_by?.display_name }}
                          </template>
                          <template v-slot:date_time>
                            <template
                              v-if="getDateCountAll(leave.rejected_at)"
                              >{{ formatDateTime(leave.rejected_at) }}</template
                            >
                            <template v-else>{{
                              formatDateTime(leave.rejected_at)
                            }}</template>
                          </template>
                          <template v-slot:format_date_time>
                            {{ formatDate(leave.rejected_at) }}
                            {{ formatDateStartTime(leave.rejected_at) }}
                          </template>
                        </TableActivity>
                      </span>
                      <span v-if="leave.status == 4">
                        <TableActivity
                          v-if="!lodash.isEmpty(leave.cancelled_by)"
                          :data="leave"
                        >
                          <template v-slot:display_name>
                            {{ leave.cancelled_by?.display_name }}
                          </template>
                          <template v-slot:date_time>
                            <template
                              v-if="getDateCountAll(leave.cancelled_at)"
                              >{{
                                formatDateTime(leave.cancelled_at)
                              }}</template
                            >
                            <template v-else>{{
                              formatDateTime(leave.cancelled_at)
                            }}</template>
                          </template>
                          <template v-slot:format_date_time>
                            {{ formatDate(leave.cancelled_at) }}
                            {{ formatDateStartTime(leave.cancelled_at) }}
                          </template>
                        </TableActivity>
                      </span>
                    </template>
                    <em v-else class="text-muted"> no action date</em>
                  </td>
                  <td class="simple-table-td">
                    <div class="d-flex align-center">
                      <template
                        v-if="
                          leave?.attachments && leave.attachments?.length > 0
                        "
                      >
                        <div
                          class="attachment-preview"
                          @click="downloadAttachment(leave.attachments[0])"
                        >
                          <template
                            v-if="isImage(leave.attachments[0].extension)"
                          >
                            <ImageTemplate
                              :src="leave.attachments[0].file.url"
                              style="max-width: 50px; width: 50px"
                            />

                            <v-tooltip top content-class="custom-top-tooltip">
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip
                                  v-bind="attrs"
                                  v-on="on"
                                  class="mx-2 d-inline-table font-weight-600"
                                  color="chip-custom-blue"
                                  label
                                  outlined
                                  small
                                >
                                  <!-- <v-icon left small>mdi-image</v-icon> -->
                                  <!-- {{ leave.attachments[0].name }} -->
                                </v-chip>
                              </template>
                              <span class="tooltip-content">
                                <div class="mb-1">
                                  <b> {{ leave.attachments[0].name }}</b>
                                </div>
                              </span>
                            </v-tooltip>
                          </template>

                          <template v-else>
                            <inline-svg
                              style="max-width: 50px; width: 50px"
                              :src="
                                $assetURL(
                                  `media/mime/${leave.attachments[0].extension}.svg`
                                )
                              "
                            />
                            <v-tooltip top content-class="custom-top-tooltip">
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip
                                  v-bind="attrs"
                                  v-on="on"
                                  class="mx-2 d-inline-table font-weight-600"
                                  color="chip-custom-blue"
                                  label
                                  outlined
                                  small
                                >
                                  <!-- <v-icon left small>mdi-file</v-icon> -->
                                  <!-- {{ leave.attachments[0].name }} -->
                                </v-chip>
                              </template>
                              <span class="tooltip-content">
                                <div class="mb-1" v-if="false">
                                  <b> {{ leave.attachments[0].name }}</b>
                                </div>
                              </span>
                            </v-tooltip>
                          </template>
                        </div>
                        <v-chip
                          v-if="leave.attachments.length > 1"
                          small
                          class="ml-2 cyan white--text"
                          @click="showAttachments(leave.attachments)"
                        >
                          +{{ leave.attachments.length - 1 }} more
                        </v-chip>
                      </template>
                      <em v-else class="text-muted">No attachments</em>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>

      <v-col class="text-center border-top" v-else>
        <p class="m-0 py-15 row-not-found text-center">
          <img
            :src="$assetURL('media/error/empty.png')"
            class="row-not-found-image"
          />
          Uhh... There are no detail at the moment.
        </p>
      </v-col>
    </v-app>
    <Dialog
      v-if="statusDialog"
      :common-dialog="statusDialog"
      :dialog-width="640"
      isClass
    >
      <template v-slot:title>
        <div class="d-flex">Confirmed</div>
      </template>
      <template v-slot:body>
        <v-form v-model="formValid">
          <v-row class="delete-dialog">
            <v-col md="12" class="py-0 my-auto py-2">
              <div class="btx-div m-0" v-if="statusdata == 'approved'">
                <span class="font-weight-600">
                  <template v-if="visits && visits.visitBarcode">
                    <div style="font-size: 19px !important">
                      Assigned Visits :-
                      <span class="font-weight-500 red--text mr-2">{{
                        visits.visitBarcode
                      }}</span>
                    </div>
                    <br />
                  </template>
                  <span style="font-size: 18px !important">
                    Are you sure, You want to Approve this Leave
                  </span>
                  <br /><br />

                  <v-chip outlined label color="green" class="ml-2"
                    ><span class="font-weight-600">{{
                      leaveBarcode
                    }}</span> </v-chip
                  >&nbsp;?
                </span>
              </div>
              <div class="btx-div m-0" v-if="statusdata == 'cancelled'">
                <span class="font-weight-600">
                  <template v-if="visits && visits.visitBarcode">
                    <div style="font-size: 19px !important">
                      Assigned Visits :-
                      <span class="font-weight-500 red--text mr-2">{{
                        visits.visitBarcode
                      }}</span>
                    </div>
                    <br />
                  </template>
                  <span style="font-size: 18px !important">
                    Are you sure, You want to Cancel this Leave
                  </span>
                  <v-chip outlined label color="teal" class="ml-2"
                    ><span class="font-weight-600">{{
                      leaveBarcode
                    }}</span> </v-chip
                  >&nbsp;?
                </span>
                <div class="mt-3" v-if="statusdata == 'cancelled'">
                  <label class="input-label required mb-1">Cancel Remark</label>
                  <v-textarea
                    auto-grow
                    dense
                    :rules="[
                      validateRules.required(cancelled_remark, 'Remark'),
                    ]"
                    filled
                    color="cyan"
                    v-model="cancelled_remark"
                    placeholder="Reason for cancellation"
                    solo
                    flat
                    row-height="15"
                  ></v-textarea>
                </div>
              </div>
              <div v-if="statusdata == 'rejected'">
                <span class="font-weight-600">
                  <span style="font-size: 19px !important">
                    Are you sure, You want to Reject this Leave
                  </span>

                  <!--  {{ leaveId.length > 1 ? "these leaves" : "this Leave" }} -->
                  <v-chip outlined label color="red" class="ml-2">
                    <span class="font-weight-600">{{
                      leaveBarcode
                    }}</span> </v-chip
                  >&nbsp; ?
                </span>

                <div class="mt-3" v-if="statusdata == 'rejected'">
                  <label class="input-label required mb-1">Reject Remark</label>
                  <v-textarea
                    auto-grow
                    dense
                    :rules="[validateRules.required(rejected_remark, 'Remark')]"
                    filled
                    color="cyan"
                    v-model="rejected_remark"
                    placeholder="Reason for leave"
                    solo
                    flat
                    row-height="15"
                  ></v-textarea>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template v-slot:action>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button white--text"
          color="cyan"
          :disabled="!formValid"
          @click="dropData(visits.visitId)"
          style="min-width: 78px !important"
        >
          <template
            v-if="
              visits &&
              visits.visitId &&
              visits.visitId.length > 0 &&
              statusdata == 'approved'
            "
          >
            Approve & UnAssigned
          </template>
          <template v-else>
            <template v-if="statusdata == 'approved'"> Approve </template>
            <template v-if="statusdata == 'cancelled'"> Cancel </template>
            <template v-if="statusdata == 'rejected'"> Reject </template>
          </template>
        </v-btn>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          @click="statusDialog = false"
        >
          Close
        </v-btn>
      </template>
    </Dialog>
    <AttachmentListModal
      :show="attachmentDialog"
      :attachments="selectedAttachments"
      v-on:close="attachmentDialog = false"
      @download="downloadAttachment"
    />
  </div>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import moment from "moment-timezone";
import DateRangePicker from "@/view/pages/partials/DateRangePicker.vue";

import JwtService from "@/core/services/jwt.service";
import { PATCH, GET } from "@/core/services/store/request.module";
import { LeaveApplyEventBus } from "@/core/lib/leave.from.lib.js";
import Dialog from "@/view/pages/partials/Dialog";
import ValidationMixin from "@/core/plugins/validation-mixin";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
import ImageTemplate from "@/view/pages/Image";
import AttachmentListModal from "@/view/components/AttachmentListModal";

export default {
  mixins: [CommonMixin, ValidationMixin],
  name: "login-log",
  props: {
    logs: {
      type: Array,
      // type: [Object, Array],
      required: true,
      default: () => {
        return new Array();
      },
    },
    user: {
      type: Array,
      default: () => {
        return new Array();
      },
      required: true,
    },
  },
  watch: {
    leaveTypes: {
      deep: true,
      immediate: true,
      handler(param) {
        this.leaveTypes = param;
      },
    },
    logs: {
      deep: true,
      immediate: true,
      handler(param) {
        this.loglist = param;
        this.updateStatusCounts();
      },
    },
  },
  components: {
    Dialog,
    TableActivity,
    ImageTemplate,
    DateRangePicker,
    AttachmentListModal,
  },
  data() {
    return {
      leaveId: null,
      duration: [],
      leaveStatusType: "all",
      attachmentDialog: false,
      selectedAttachments: [],
      visits: [],
      extensionArray: ["jpg", "png", "gif", "jpeg", "webp", "tiff", "jfif"],
      leaveTypes: [],
      leaveBarcode: null,
      CurrentUser: JwtService.currentUser(),
      statusDialog: false,
      detailDialog: false,
      statusdata: null,
      rejected_remark: null,
      cancelled_remark: null,
      pageLoading: false,
      statusCounts: {
        all: 0,
        pending: 0,
        accepted: 0,
        rejected: 0,
        cancelled: 0,
      },

      statusDropdown: [
        {
          text: "Approved",
          value: "approved",
          color: "green",
          headercolor: "primary",
          status: "2",
        },
        {
          text: "Rejected",
          value: "rejected",
          color: "red",
          headercolor: "primary",
          status: "3",
        },
        {
          text: "Cancelled",
          value: "cancelled",
          color: "teal",
          headercolor: "primary",
          status: "1",
        },
      ],
      loglist: [],
    };
  },
  computed: {
    filteredLogs() {
      if (this.leaveStatusType === "all") {
        return this.loglist;
      }
      return this.loglist.filter((leave) => {
        if (this.leaveStatusType === "pending") return leave.status === 1;
        if (this.leaveStatusType === "accepted") return leave.status === 2;
        if (this.leaveStatusType === "rejected") return leave.status === 3;
        if (this.leaveStatusType === "cancelled") return leave.status === 4;
        return true;
      });
    },
  },
  methods: {
    isImage(ext) {
      if (find(this.extensionArray, (row) => row == ext.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },
    formatFileSize(bytes) {
      if (!bytes) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    downloadAttachment(attachment) {
      window.open(attachment.file.url, "_blank");
    },
    showAttachments(attachments) {
      this.selectedAttachments = attachments;
      this.attachmentDialog = true;
    },
    isDisabled(leave) {
      return leave.status == 1 && this.CurrentUser.role == 1 ? false : true;
    },
    updateStatus(status, row) {
      this.statusDialog = true;
      this.leaveId = row.id;
      this.visits = row;
      this.visitBarcode = row.barcode;
      this.leaveBarcode = row.barcode;
      this.statusdata = status;
    },
    formatDateStartTime(row) {
      return moment(row).format("hh:mm A");
    },
    objectLength() {
      // Use Object.keys() to get an array of keys in the object
      return Object.keys(this.logs).length;
    },
    dropData(visit) {
      this.autoRefresh = false;
      this.pageLoading = true;
      let payload = {
        visit: visit,
        leaves: this.leaveId,
        status: this.statusdata, // 1: Pending, 2: Approved, 3: Rejected 4: cancelled
        remark:
          this.statusdata == "rejected"
            ? this.rejected_remark
            : this.statusdata == "cancelled"
            ? this.cancelled_remark
            : null,
      };
      this.$store
        .dispatch(PATCH, {
          url: `leave/${this.leaveId}/${this.statusdata}`,
          data: payload,
        })
        .then(() => {
          this.statusDialog = false;
          this.detailDialog = false;
          this.reject_remark = null;
          this.autoRefresh = true;
          LeaveApplyEventBus.$emit("refresh");
          this.$emit("refresh", true);
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    getLeaveTypes() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "leave-types?all=true" })
        .then(({ data }) => {
          _this.leaveTypes = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    updateStatusCounts() {
      this.statusCounts = {
        all: this.loglist.length,
        pending: this.loglist.filter((leave) => leave.status === 1).length,
        accepted: this.loglist.filter((leave) => leave.status === 2).length,
        rejected: this.loglist.filter((leave) => leave.status === 3).length,
        cancelled: this.loglist.filter((leave) => leave.status === 4).length,
      };
    },

    redirectToDetail(leave) {
      this.$router.push({
        name: "admin.leave.detail",
        params: { id: leave.id },
      });
    },
  },

  mounted() {
    this.getLeaveTypes();
  },
};
</script>
